import { Box, Text } from '@chakra-ui/react';
import i18next from 'i18next';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { COMMON_WEB_PATH } from '../../../constant';
import useCheckLogin from '../../../hook/useCheckLogin';

const LoginButton = () => {
  const { t } = useTranslation();
  const i18n_header = (key) => t(`header.${key}`);

  const { isMachineUser } = useCheckLogin();

  const iconSize = useMemo(() => {
    return {
      base: '45px',
      md: '50px',
      xl: '60px'
    };
  }, []);

  return (
    <Box
      as={Link}
      to="signin"
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={'center'}
      justifyContent={'center'}
      height={iconSize}
      w={{
        base: '110px',
        xl: '130px'
      }}
      bgImage={`url('${COMMON_WEB_PATH}/blue-layout/header_button/${i18next.language}/header_login.png')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100%100%"
    ></Box>
  );
};

export default LoginButton;
